export const _LOAD_PUZZLE_NUMBER_SQUARE_MODEL_ = 'Load:PuzzleNumberSquarePuzzle';
export const ANSWER_COLOR = '#ff2c2c';

export const OPERATOR_WEIGHTS = {
  easy: {
    plus: 70, minus: 30, times: 0, divide: 0,
  },
  medium: {
    plus: 40, minus: 40, times: 20, divide: 0,
  },
  hard: {
    plus: 20, minus: 30, times: 40, divide: 10,
  },
  random: {
    plus: 25, minus: 25, times: 25, divide: 25,
  },
};

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  shape: null,
  value: null,
  filled: true,
  color: null,
  direction: null,
  isBlocked: false,
  isResult: false,
};

export const SETTINGS = {
  showAnswer: true,
  difficulty: 'medium',
  colored: true,
  maxValue: 9,
  enablePercentageDistribution: false,
  operatorWeights: { ...OPERATOR_WEIGHTS.medium },
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 6,
  rows: 4,
  columns: 4,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;
